import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: inline-block;

  .locked-content {
    pointer-events: none;
    opacity: 0.5;
  }

  .lock-badge {
    position: absolute;
    right: -6px;
    bottom: -6px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background-color: ${(props) => props.theme.$warning};
    color: ${(props) => props.theme.$black};

    i {
      font-size: 14px;
    }
  }

  &.variant-card {
    @media only screen and (max-width: 768px) {
      display: block;
      width: 100%;
    }
  }

  &.variant-inline .lock-badge {
    width: 18px;
    height: 18px;
    border-radius: 4px;

    i {
      font-size: 12px;
    }
  }
`;
